import React from 'react';
import GIETextField from '../../components/GIETextField/GieTextField';
import {ValidatorForm} from 'react-material-ui-form-validator';
import GIEButton from '../../components/GIEButton/GieButton';
import {FormValidator} from '../../util/form-validator';
import InformationsController from '../../controller/informations.controller';
import GIECheckBox from '../../components/GIECheckBox/GieCheckBox';
import userInformations from '../../userInformation/user_informations';
import GIELink from "../../components/GIELink/GIELink";

export default class EmergencyFormDetail extends React.Component<any, any> {
  formValidator: FormValidator = new FormValidator();
  informationsController: InformationsController = new InformationsController();

  constructor(props: any) {
    super(props);
    this.state = {
      isValid: true,
      formControls: {
        lastName: {
          value: '',
          error: false,
          errorMessage: ''
        },
        email: {
          value: '',
          error: false,
          errorMessage: ''
        },
        phoneNumber: {
          value: '',
          error: false,
          errorMessage: ''
        },
        adresse: {
          value: '',
          error: false,
          errorMessage: ''
        },
        city: {
          value: '',
          error: false,
          errorMessage: ''
        },
        customerNumber: {
          value: '',
          error: false,
          errorMessage: ''
        },
        contractNumber: {
          value: '',
          error: false,
          errorMessage: ''
        },
        confidentiality: {
          value: '',
          error: false,
          errorMessage: ''
        }
      }
    }
    this.checkValidForm = this.checkValidForm.bind(this);
  }

  componentDidMount() {
    const noContract = userInformations.getNoContract();
    if (noContract == null || noContract.length === 0) {
      window.location.href = "/admin/login"
    } else {
      this.informationsController.getUserInformations().then((data: any) => {
        this.getData(data, noContract)
      }).catch(err => {
        console.log(err)
      })
    }
  }

  getData = (data: any, noContract: string) => {
    let formControls = this.state.formControls;
    formControls.lastName.value = data.user.name;
    formControls.email.value = data.user.email;
    formControls.phoneNumber.value = data.user.phone_no;
    formControls.adresse.value = data.user.address;
    formControls.customerNumber.value = data.user.no;
    formControls.contractNumber.value = data.contract.contractNo;
    formControls.city.value = data.user.city;

    this.setState({formControls})
  }

  checkValidForm = () => {
    let formControls = this.state.formControls;
    let isError = false;
    const nonRequiredFields = ['phoneMobile', 'phoneHome', 'phoneOffice'];
    Object.keys(formControls).forEach(name => {
      if (!nonRequiredFields.includes(name)) {
        const error = this.formValidator.returnError(formControls[name].value, name)
        formControls[name].error = error.error;
        formControls[name].errorMessage = error.errorMessage;
        if (error.error === true) {
          isError = true
        }
      }
    });
    this.setState({formControls, isValid: !isError})
    return isError;
  }

  handleSubmit = () => {
    if (this.checkValidForm() === false) {
      this.setState({sending: true});
      this.props.emit(this.state.formControls, this.handleSentOrError);
    }
  }

  handleSentOrError = () => {
    this.setState({sending: false});
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const error = this.formValidator.returnError(value, name);
    this.setState({
      formControls: {
        ...this.state.formControls,
        [name]: {
          ...this.state.formControls[name],
          value,
          error: error.error,
          errorMessage: error.errorMessage
        }
      }
    });
    setTimeout(() => {
      this.checkValidForm() ? this.setState({isValid: true}) : this.setState({isValid: false})
    }, 100);
  }

  checkCGV = (event) => {
    let formControls = this.state.formControls;
    formControls.confidentiality.value = !formControls.confidentiality.value
    this.setState({formControls})
  }

  render() {
    return (
      <div>
        <ValidatorForm ref="form" onSubmit={this.handleSubmit} instantValidate
                       onError={errors => console.log(errors)}>
          <GIETextField label="Nom du titulaire"
                        required
                        disabled
                        onChange={this.changeHandler}
                        name="lastName"
                        value={this.state.formControls.lastName.value}
                        helperText={this.state.formControls.lastName.errorMessage}
                        error={this.state.formControls.lastName.error}/>
          <GIETextField label="Adresse du site"
                        required
                        disabled
                        onChange={this.changeHandler}
                        name="adresse"
                        value={this.state.formControls.adresse.value}
                        id="my-input"
                        aria-describedby="my-helper-text"
                        error={this.state.formControls.adresse.error}
                        helperText={this.state.formControls.adresse.errorMessage}/>
          <GIETextField label="Ville du site"
                        required
                        disabled
                        onChange={this.changeHandler}
                        name="city"
                        value={this.state.formControls.city.value}
                        error={this.state.formControls.city.error}
                        helperText={this.state.formControls.city.errorMessage}/>
          <GIETextField label="Votre email"
                        onChange={this.changeHandler}
                        name="email"
                        required
                        value={this.state.formControls.email.value}
                        helperText={this.state.formControls.email.errorMessage}
                        error={this.state.formControls.email.error}/>
          <GIETextField label="Votre n° de téléphone"
                        required
                        onChange={this.changeHandler}
                        name="phoneNumber"
                        value={this.state.formControls.phoneNumber.value}
                        error={this.state.formControls.phoneNumber.error}
                        helperText={this.state.formControls.phoneNumber.errorMessage}/>
          <GIETextField label="Votre numéro de client"
                        required
                        disabled
                        onChange={this.changeHandler}
                        name="customerNumber"
                        value={this.state.formControls.customerNumber.value}
                        error={this.state.formControls.customerNumber.error}
                        helperText={this.state.formControls.customerNumber.errorMessage}/>
          <GIETextField label="Votre numéro de contrat"
                        required
                        disabled
                        onChange={this.changeHandler}
                        name="contractNumber"
                        value={this.state.formControls.contractNumber.value}
                        helperText={this.state.formControls.contractNumber.errorMessage}
                        error={this.state.formControls.contractNumber.error}/>
          <GIECheckBox checked={this.state.formControls.confidentiality.value === true}
                       name="confidentiality"
                       errorText={this.state.formControls.confidentiality.errorMessage}
                       error={this.state.formControls.confidentiality.error}
                       emit={(event) => this.checkCGV(event)}
                       label="En cochant cette case, j’accepte que mes données personnelles soient utilisées par GIE à des fins de traitement de ma demande"/>
          <div className="d-flex justify-content-between align-items-center my-4">
            <GIELink href="javascript:void(0)" onClick={this.props.previous} arrowBefore>Précédent</GIELink>
            {this.state.sending ?
              <GIEButton disabled classes={{root: 'blue-btn'}}>Envoi en cours...</GIEButton>
              :
              <GIEButton onClick={this.handleSubmit} classes={{root: 'blue-btn'}}>Envoyer</GIEButton>
            }
            <div></div>
          </div>
        </ValidatorForm>
      </div>
    );
  }
}
